/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-13 10:27:22
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-01 14:55:42
 */
import React, { useState } from 'react'
import Avatar from 'antd/lib/avatar/avatar'
import axios from 'axios'
import { connect } from 'react-redux'
import { message } from 'antd'
import FindNothing from '../components/DefaultView/FindNothing'
import { addchat, sendmessageprivate } from '../../../../service/loginaction'
import { transformtime } from '../../../../utils/tools'
import { getfriendapp, loadfriendList } from '../service/loaddata'
import moreimg from '../../../../resources/img/icon-more (3).png'
class NewFriend extends React.Component {

    state = {
        applylist: []
    }

    componentDidMount() {

    }

    render() {
        return (<div className='newfriend-panel'>
            {/* <button onClick={this.loaddata}>刷新（测试用）</button> */}
            <div className='chat-content-title'>{'好友申请列表'}
                <img alt='' src={moreimg} style={{ float: 'right', cursor: 'pointer', marginRight: 20, marginTop: 4 }}></img>
            </div>
            <div className='newfriend-content'>
                {this.props.friendApplication.length === 0 ? <FindNothing></FindNothing> : this.props.friendApplication.map((data, index) => <NewFriendEntity key={data.serial} data={data}></NewFriendEntity>)}
            </div>
        </div>)
    }
}

const NewFriendEntity = (props) => {
    const [validate, setvalidate] = useState(props.data.validateFlag)
// debugger
    function agree(value) {
        axios.put(`${global.serviceUrl.chat}/apply/validate`, {
            "serial": props.data.serial,
            "validateFlag": value
        }).then((data) => {
            setvalidate(value)
            loadfriendList()
            // addchat(props.data.userInfo.userId, 'private')
            addchat(props.data.userInfo, 'private')
            sendmessageprivate(props.data.userInfo.userId, '我们已经是好友了', 'text')
            getfriendapp()
        }).catch((e) => {

        })
    }
    if (!props.data.userInfo) {
        return null
    }

    return (
        <div className='newfriend-entity-panel'>
            <Avatar shape='square' src={global.yunguanAvatar + props.data.userInfo.avatar} className='newfriend-entity-avatar'></Avatar>
            <div className='newfriend-entity-infopanel'>
                <div className='newfriend-entity-username'>
                    {props.data.userInfo.userName}
                </div>
                <div className='newfriend-entity-time'>
                    {transformtime(props.data.createTime, 'yyyy-mm-dd')}
                </div>
                <div className='newfriend-entity-message'>
                    {props.data.content}
                </div>
            </div>
            <div className='newfriend-entity-buttonpanel'>
                {
                    validate == '0' ? <><button className='newfriend-entity-btn-agree' onClick={agree.bind(this, '1')}>同意</button>
                        <button className='newfriend-entity-btn-refuse' onClick={agree.bind(this, '2')}>拒绝</button></>
                        : validate == '2' ? <div className='newfriend-entity-refused'>已拒绝</div>
                            : validate == '1' ? <div className='newfriend-entity-agreed'>已同意</div> : <></>
                }


            </div>


        </div>
    )

}

const mapState = state => ({
    // activeRoom: state.userReducer.get('activeRoom'),
    user: state.userReducer.get('user').toJS(),
    friendApplication: state.userReducer.get('friendApplication').toJS(),
})

const mapDispatch = dispatch => ({
})

export default connect(
    mapState,
    mapDispatch
)(NewFriend)
// export default NewFriend